
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24","cy":"24","r":"20","fill":"#26a69a"}}),_c('path',{attrs:{"fill":"#fff","d":"M15 13h18v5H15zM24 21c-4.457 0-12 .737-12 3.5S19.543 28 24 28s12-.737 12-3.5S28.457 21 24 21zm0 5c-5.523 0-10-.895-10-2s4.477-2 10-2 10 .895 10 2-4.477 2-10 2z"}}),_c('path',{attrs:{"fill":"#fff","d":"M24 24a44.67 44.67 0 003-.098V13h-6v10.902A44.67 44.67 0 0024 24zM25.723 25.968l-.336.01c-.455.013-.915.022-1.387.022a52.332 52.332 0 01-3-.091V36h6V25.908c-.414.026-.842.045-1.277.06z"}})])
          )
        }
      }
    